<script setup>
import { reactive } from 'vue';

let props = defineProps({
    type: {
        type: String,
        required: true,
        validator(value) {
            return ['absolute', 'block'].includes(
                value
            );
        },
    },
});
let divClasses = reactive({
    absolute: 'absolute left-2 top-2 rounded bg-wgn-purple-3 align-middle',
    block: 'align-middle items-center',
});
</script>

<template>
    <div
        class=""
        :class="divClasses[props.type]"
    >
        <span class="px-2 py-1">
            <slot />
        </span>
    </div>
</template>
